// Add your custom JS here.



// Clicks de les respostes als Quizs
jQuery(".respostes .opcio").on("click", function() {


	// Codi per poder verure totes les respostes
		jQuery(this).siblings().removeClass("active");
		jQuery(".opcio").removeClass("show");

		jQuery(this).addClass("active");	// Activo la opció seleccionada
	  	jQuery(this).siblings().addClass("disabled"); // Desactivo les altres opcions  

		let opcio = jQuery(this).index();

        jQuery(this).parent().siblings(".explicacions").find(".opcio").eq(opcio).addClass("show");
	// FI - TOTES respostes


  	if(jQuery('#'+jQuery(this).closest(".modal").attr("id")).find(".pregunta").length == jQuery('#'+jQuery(this).closest(".modal").attr("id")).find(".opcio.active").length) {
 		// jQuery('#'+jQuery(this).closest(".modal").attr("id")).find(".btn-close").addClass("close-quiz");
		jQuery(".close-quiz").addClass("active");

 		jQuery(".close-quiz").addClass("heartbeat")
	    setTimeout(function(){
	    	jQuery(".close-quiz").removeClass("heartbeat")
	    }, 2000);


  	} else {
  	  	// Activo el botó NEXT
  		jQuery('#'+jQuery(this).closest(".modal").attr("id")).find(".swiper-button-next").removeClass("button-disabled");
  	}
})




/*----------------------------------------------------
  FLIP CARD
-----------------------------------------------------*/


// Swiper FLIPCARDS - Loop through all destacat sections
jQuery(".destacat").each(function(index) {
	var destacatElement = jQuery(this);
	var destacatId = destacatElement.attr("id");

	// Desactivar botó Next
	destacatElement.find(".swiper-button-next").addClass("button-disabled");

	// Initialize Swiper for this destacat
	var slider = new Swiper('#' + destacatId + ' .swiper-container', {
		// Optional parameters
		loop: false,
		// If we need pagination
		pagination: {
			el: '#' + destacatId + ' .swiper-pagination',
			clickable: false,
			renderBullet: function (index, className) {
				return '<span class="' + className + '"></span>';
			},
		},
		initialSlide: 0,
		allowTouchMove: false,

		// Navigation arrows
		navigation: {
			nextEl: '#' + destacatId + ' .swiper-button-next',
		},
	});
});

	  

// Clicks als botons SI / NO de les FLIPCARDS
var flipcardsButtons = jQuery(".flipcardsi ,.flipcardno, .flipcardview");

flipcardsButtons.on('click', function(e) {
  	e.stopPropagation();

	console.log("Has clicat a una flipcard");
  	if(jQuery(this).siblings(".flipcard").hasClass('card--flipped')) {
    	jQuery(this).siblings(".flipcard").addClass('card--unflip');
    	console.log("card--flipped");
    	setTimeout(function(){
      		jQuery(this).siblings(".flipcard").removeClass('card--flipped', 'card--unflip');
    	}, 500);
  	} else { 
    	jQuery(this).siblings(".flipcard").addClass("card--flipped");
  	}

  	if(jQuery(this).hasClass("flipcardsi")) {
  		jQuery(this).hide();
  		jQuery(this).siblings(".flipcardno").hide();
  	}
  	if(jQuery(this).hasClass("flipcardno")) {
  		jQuery(this).hide();
    	jQuery(this).siblings(".flipcardsi").hide();
  	}

  	if(jQuery(this).siblings(".card--flipped").hasClass("card--unflip")) {
//  	if(jQuery(this).hasClass("flipcardview")) {
  		jQuery(this).hide();
  	}

	console.log("Comparo: ",  jQuery('#'+jQuery(this).closest(".destacat").attr("id")).find(".swiper-slide").length, " i ", jQuery('#'+jQuery(this).closest(".destacat").attr("id")).find(".card--flipped").length );

	if(jQuery('#'+jQuery(this).closest(".destacat").attr("id")).find(".swiper-slide").length == jQuery('#'+jQuery(this).closest(".destacat").attr("id")).find(".card--flipped").length) {
		// jQuery('#'+jQuery(this).closest(".modal").attr("id")).find(".btn-close").addClass("close-quiz");
		jQuery(".close-quiz").addClass("active");

 		jQuery(".close-quiz").addClass("heartbeat")
	    setTimeout(function(){
	    	jQuery(".close-quiz").removeClass("heartbeat")
	    }, 2000);

	} else {
  	  	// Activo el botó NEXT
		console.log("Activo el botó NEXT",jQuery('#'+jQuery(this).closest(".destacat").attr("id")).find(".swiper-button-next"));
  		jQuery('#'+jQuery(this).closest(".destacat").attr("id")).find(".swiper-button-next").removeClass("button-disabled");		
	}


});


// Desactivar botó NEXT dels slides quan es prem
jQuery(".swiper-button-next").on("click",function() {
	jQuery(this).addClass("button-disabled");
})